import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
    platform: null,
    current: null,
    min: null,
    link: null,
};

// validation form
model.validForm = {
    platform: [ValidService.required],
    current: [ValidService.required],
    min: [ValidService.required],
    link: [ValidService.required],
};

// dữ liệu mẫu các form khác
model.dataFormOther = {};

// validation các form khác
model.validFormOther = {
};

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["createdTime", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {},
        valid: {},
        operator: {}
    }
};

export default model;